import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-5"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = {
  key: 0,
  class: "row row-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.appconfig.sectionTitle), 1)
              ])
            ]),
            (_ctx.cards.Cards.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards.Cards, (card) => {
                    return (_openBlock(), _createBlock(_component_Card, {
                      key: card.Url,
                      card: card
                    }, null, 8, ["card"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.showButton)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          onClicked: _ctx.getCards,
          disabled: _ctx.buttonDisabled
        }, null, 8, ["onClicked", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}